import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

export const fetchConversationsAction = createAsyncThunk(
  "conversations/fetchConversations",
  async ({ chatId }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/Conversations/Get-Conversation/${chatId}`,
        {chatId}
      );

      if (response.status === 200) {
        console.log("API Response:", response.data);
        return { chatId, data: response.data.details };
      } else {
        return thunkAPI.rejectWithValue(
          response.data.details || "Error fetching conversations"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);

export const toggleAdminConversationsAction = createAsyncThunk(
  "conversations/toggleAdminConversations",
  async (payload, thunkAPI) => {
    try {
      const { LeadAssignmentId } = payload;

      const response = await axiosInstance.post(
        "/Conversations/Toggle-Agent-Conversations",
        { LeadAssignmentId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Toggle API Response:", response.data);
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data || "Error toggling admin conversations"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendMessageAction = createAsyncThunk(
  "conversations/sendMessage",
  async ({ LeadAssignmentId, Message, chatId }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        "/Conversations/Agent-User-Interaction",
        { LeadAssignmentId, Message },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Send Message API Response:", response.data);
        // Use chatId instead of LeadAssignmentId for fetching conversations
        if (chatId) {
          thunkAPI.dispatch(fetchConversationsAction({ chatId }));
        }
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data || "Error sending message"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// export const getAllConversationList = createAsyncThunk(
//   'conversations/getAllConversation',
//   async (thunkAPI) => {
//     try {
//       const response = await axiosInstance.get("")
//     }
//     catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);

//     }
//   }
// )
